import { useMemo } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid2 as Grid, Typography } from "@mui/material";
import { LargeActionButton } from "../Common/LargeActionButton";
import OrdersIcon from "../../icons/Orders";
import { useStyles } from "./PriorityStock.styles";
import { PriorityStockDialogProps } from "./types";
import { PriorityStockGroups } from "./PriorityStockGroups";
import { priorityStockFlagsArray } from "./constants";

export const PriorityStockDialog = ({ isOpen, onClose, purchaseOrderPriorityStock }: PriorityStockDialogProps) => {
	const classes = useStyles();

	const handleReturnToDashboard = () => {
		onClose();
	};

	const priorityStockGroups = useMemo(() => {
		return (
			<PriorityStockGroups
				priorityStockFlagsArray={priorityStockFlagsArray}
				purchaseOrderPriorityStock={purchaseOrderPriorityStock}
			/>
		);
	}, [purchaseOrderPriorityStock]);

	return (
		<Dialog open={isOpen} scroll="body" fullScreen>
			<DialogTitle component="div">
				<Grid container spacing={0} direction="column" alignItems="center">
					<Grid size={12} container justifyContent="center">
						<OrdersIcon />
					</Grid>

					<Grid size={12} container justifyContent="center">
						<Typography variant="subtitle1" component="div">
							<strong>Priority stock on delivery</strong>
						</Typography>
					</Grid>
					{purchaseOrderPriorityStock.poNumber && (
						<Grid size={12} className={classes.purchaseOrderPriorityStockTextContainer}>
							<Typography variant="subtitle2" component="div" className={classes.typographySubtitle2}>
								<>
									<strong>PO {purchaseOrderPriorityStock.poNumber}</strong> contains high priority items.
								</>
							</Typography>
						</Grid>
					)}
				</Grid>
			</DialogTitle>

			<DialogContent>{priorityStockGroups}</DialogContent>

			<DialogActions>
				<Grid container justifyContent="flex-start" sx={{ width: '100%' }}>
					<Grid size={12}>
						<LargeActionButton onClick={handleReturnToDashboard}>Return to dashboard</LargeActionButton>
					</Grid>
				</Grid>
			</DialogActions>
		</Dialog>
	);
};
